<!-- <li class="panel"> -->
    <ng-template [ngIf]="entity">
        <div class="controparte">
                <p class="col-sm-2">
                    <button (click)="emitEntity(entity)" class="btn btn-primary associa"
                        type="submit">Allega</button>
                </p>
                <p class=" col-sm-6" *ngIf="entity.esito" style="padding-left:15px;">
                    Provvedimento N. <strong>&nbsp;{{entity.esito.numeroEsito}}</strong>
                </p>
                <p class=" col-sm-5" *ngIf="entity.esito">
                      <strong>{{entity.esito.tipoEsito.descrizione}}</strong>
                </p>
        </div>
        </ng-template>
        <!-- </li> -->